import React from 'react';
import logo from '../img/logosxc.png';
import './Spinner.css';

export default function Spinner() {
  return (
    <div className="spinner-container">
      <div className="spinner-wrapper">
        <img src={logo} alt="School Logo" className="spinner-logo" />
        <div className="spinner-ring"></div>
      </div>
      <p className="spinner-text">Loading...</p>
    </div>
  );
}
